<script>
    export let tic;
</script>
<svg
                class={tic}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <path d="M10 12h-7l3 -3m0 6l-3 -3" />
                <path d="M14 12h7l-3 -3m0 6l3 -3" />
                <path d="M3 6v-3h18v3" />
                <path d="M3 18v3h18v-3" />
              </svg>